export const DOCUMENT_REGISTER_LIST_PATH = "/document-register";
export const DOCUMENT_REGISTER_TAB_PARAM = "tab";
export const DOCUMENT_REGISTER_ALL_TAB = "all";
export const DOCUMENT_REGISTER_MY_TEAM_TAB = "my team";
